import React from "react"

import { colors } from "@bullseye/tailwind-config"

import { IconProps } from "./IconProps"

const CalendarIcon: React.FC<IconProps> = ({
  scale = 1,
  lineScale = 1,
  color = colors.brand.indigo[1],
  bgColor = colors.blue[50],
  outline = true,
  ...rest
}) => (
  <svg
    viewBox="0 0 48 48"
    width={scale * 48}
    height={scale * 48}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Calendar"
    {...rest}
  >
    {outline && <rect width="48" height="48" rx="24" fill={bgColor} />}
    <path
      d="M31 16H17C15.8954 16 15 16.8954 15 18V32C15 33.1046 15.8954 34 17 34H31C32.1046 34 33 33.1046 33 32V18C33 16.8954 32.1046 16 31 16Z"
      stroke={color}
      strokeWidth={lineScale * 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 14V18"
      stroke={color}
      strokeWidth={lineScale * 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 14V18"
      stroke={color}
      strokeWidth={lineScale * 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 22H33"
      stroke={color}
      strokeWidth={lineScale * 1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CalendarIcon
